import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import { listOfData } from "../../api/commonApi";
import {
  addBdeInterview,
  listOfBde,
  listOfEmployeeBdeData,
  updateBdeInterview,
} from "../../api/bdeApi";
import { BDEDuration, BDERound, BDEStatus, ResponseStatusEnum } from "../../utils/helpers/enums";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/common/loader";
import { checkStatusCodeSuccess, CommonLabel, Roles } from "../../utils/helpers/common";
import { BdeLabel } from "../../common/constant/Bde";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseInput from "../../components/BaseComponents/BaseInput";
import BaseButton from "../../components/BaseComponents/BaseButton";

const BdeAddEdit = () => {
  document.title = BdeLabel.BDEForm;
  const [loading, setLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [company, setCompany] = useState();
  const [selectedClient, setSelectedClient] = useState();
  const [aliased, setAliased] = useState();
  const [employee, setEmployee] = useState();
  const [tech, setTeach] = useState();
  const [listOfDataHR, setListOfDataHR] = useState();
  const [listOfBdeData, setListOfBdeData] = useState();
  const [selectedCompanyId, setSelectedCompanyId] = useState();

  const navigate = useNavigate();
  const { bdeId } = useParams();

  useEffect(() => {
    setLoading(true);

    if (!isNaN(bdeId)) {
      listOfBde({ id: bdeId })
        .then((response) => {
          setListOfBdeData(response?.data?.data?.[0]);
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [bdeId]);

  useEffect(() => {
    setLoading(true);
    listOfData({
      modelName: "companyModel",
      selectionCriteria: ["id", "companyName"],
      condition: {
        isDeleted: false,
      },
    })
      .then((response) => {
        setCompany(response?.data?.map((item) => ({
          value: item?.id,
          label: item?.companyName,
        })));
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });

    listOfData({
      modelName: "alisedNameModel",
      selectionCriteria: ["id", "alisedName"],
      condition: {
        isDeleted: false,
      },
    })
      .then((response) => {
        setAliased(
          response?.data?.map((item) => ({
            value: item?.id,
            label: item?.alisedName,
          }))
        );
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });

    listOfEmployeeBdeData({
      isDeleted: false,
      role: [Roles.Employee],
    })
      .then((response) => {
        setEmployee(response?.data?.data?.map((res) => {
          return {
            value: res?.id,
            label: res?.developerName,
          };
        }));
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });

    listOfData({
      modelName: "technologyModel",
      selectionCriteria: ["id", "techName"],
      condition: {
        isDeleted: false,
      },
    })
      .then((response) => {
        setTeach(response?.data?.map((item) => ({
          value: item?.id,
          label: item?.techName,
        })));
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });

    listOfEmployeeBdeData({
      isDeleted: false,
      role: [Roles.BDE, Roles.Admin, Roles.HR],
    })
      .then((response) => {
        setListOfDataHR(response?.data?.data?.map((item) => ({
          value: item?.id,
          label: item?.developerName,
        })));
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    if (selectedCompanyId !== undefined || selectedCompanyId !== null) {
      listOfData({
        modelName: "clientModel",
        selectionCriteria: ["id", "clientName"],
        condition: {
          companyId : selectedCompanyId,
          isDeleted: false,
        },
      })
        .then((response) => {
          setSelectedClient(
            response?.data?.map((status) => ({
              value: status?.id,
              label: status?.clientName,
            }))
          );
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedCompanyId]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      dateOfInterview: listOfBdeData?.dateOfInterview || "",
      experience: Number(listOfBdeData?.yearOfExperience) || "",
      technology: listOfBdeData?.bdeTechnology?.[0]?.technology?.id || "",
      alised_name: listOfBdeData?.alisedName?.id || "",
      developer_name: listOfBdeData?.authUser?.id || "",
      scheduledBy: listOfBdeData?.scheduledId || "",
      bdeStatus: listOfBdeData?.status || "",
      round: listOfBdeData?.round || "",
      remark: listOfBdeData?.remark || "",
      clientId: listOfBdeData?.client?.id || "",
      companyId: listOfBdeData?.company?.id || "",
    },
    validationSchema: Yup.object({
      dateOfInterview: Yup.date().required(
        validationMessages.required(BdeLabel.DateOfInterview)
      ),
      experience: Yup.string().required(
        validationMessages.required(BdeLabel.YearOfExp)
      ),
      technology: Yup.string().required(
        validationMessages.required(BdeLabel.Technology)
      ),
      alised_name: Yup.string().required(
        validationMessages.required(BdeLabel.AlisedName)
      ),
      developer_name: Yup.string().required(
        validationMessages.required(BdeLabel.DeveloperName)
      ),
      scheduledBy: Yup.string().required(
        validationMessages.required(BdeLabel.ScheduleBy)
      ),
      bdeStatus: Yup.string().required(
        validationMessages.required(CommonLabel.Status)
      ),
      remark: Yup.string().optional(),
      round: Yup.string().required(validationMessages.required(BdeLabel.Round)),
      companyId: Yup.string().required(
        validationMessages.required(BdeLabel.CompanyName)
      ),
      clientId: Yup.string().required(
        validationMessages.required(BdeLabel.ClientName)
      ),
    }),
    onSubmit: (values) => {
      setBtnLoader(true);
      const payload = {
        dateOfInterview: values.dateOfInterview,
        yearOfExperience: String(values.experience),
        technologyId: [parseInt(values.technology)],
        alisedId: values.alised_name,
        clientId: values.clientId,
        companyId: values.companyId,
        scheduledId: values.scheduledBy,
        userId: values.developer_name,
        status: values.bdeStatus,
        round: values.round,
        ...(values.remark && { remark: values.remark }),
      };
      if (bdeId === undefined) {
        addBdeInterview(payload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              validation.resetForm();
              navigate("/bde");
              toast.success(res?.data?.message);
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setBtnLoader(true);
        updateBdeInterview(bdeId, { ...payload })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              validation.resetForm();
              navigate("/bde");
              toast.success(response?.data?.message);
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  const [selectedOs, setSelectedOs] = useState(null);

  const enable = (bdeId === undefined) ? selectedCompanyId === undefined : false
  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <BreadCrumb
          title={bdeId === undefined ? BdeLabel.AddBDE : BdeLabel.UpdateBDE}
          pageTitle={Roles.BDE}
        />
        <Row className="mb-2">
          <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
            <h5 className="fw-semibold mt-2">
              {bdeId === undefined ? CommonLabel.Submit : CommonLabel.Update}{" "}
              {Roles.BDE}
            </h5>
          </div>
          <div className="col-auto order-2 order-sm-3 ms-auto">
            <div className="hstack gap-2">
              <Link to={"/bde"} className="btn btn-primary">
                {CommonLabel.Back}
              </Link>
            </div>
          </div>
        </Row>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <Card>
            <CardBody>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="companyId"
                      label={BdeLabel.CompanyName}
                      placeholder={SelectPlaceHolder(BdeLabel.CompanyName)}
                      options={company}
                      value={validation.values.companyId}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                        setSelectedCompanyId(value);
                      }}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.companyId}
                      error={validation.errors.companyId}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="clientId"
                      label={BdeLabel.ClientName}
                      placeholder={SelectPlaceHolder(BdeLabel.ClientName)}
                      options={selectedClient}
                      value={validation.values.clientId}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.clientId}
                      error={validation.errors.clientId}
                      isDisabled={enable}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="developer_name"
                      label={BdeLabel.DeveloperName}
                      placeholder={SelectPlaceHolder(BdeLabel.DeveloperName)}
                      options={employee}
                      value={validation.values.developer_name}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }
                      }
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.developer_name}
                      error={validation.errors.developer_name}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="alised_name"
                      label={BdeLabel.AlisedName}
                      placeholder={SelectPlaceHolder(BdeLabel.AlisedName)}
                      options={aliased}
                      value={validation.values.alised_name}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }
                      }
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.alised_name}
                      error={validation.errors.alised_name}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="technology"
                      label={BdeLabel.Technology}
                      placeholder={SelectPlaceHolder(BdeLabel.Technology)}
                      options={tech}
                      value={validation.values.technology}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }
                      }
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.technology}
                      error={validation.errors.technology}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="experience"
                      label={BdeLabel.YearOfExp}
                      placeholder={SelectPlaceHolder(BdeLabel.YearOfExp)}
                      options={BDEDuration}
                      value={validation?.values?.experience}
                      handleChange={(name, value) =>
                        validation.setFieldValue(name, value)
                      }
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.experience}
                      error={validation.errors.experience}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseInput
                      name="dateOfInterview"
                      label={BdeLabel.DateOfInterview}
                      placeholder={InputPlaceHolder(BdeLabel.DateOfInterview)}
                      type="date"
                      value={validation.values.dateOfInterview}
                      onChange={(e) =>
                        validation.setFieldValue(
                          "dateOfInterview",
                          e.target.value
                        )
                      }
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.dateOfInterview}
                      error={validation.errors.dateOfInterview}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="scheduledBy"
                      label={BdeLabel.ScheduleBy}
                      placeholder={SelectPlaceHolder(BdeLabel.ScheduleBy)}
                      options={listOfDataHR}
                      value={validation.values.scheduledBy}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.scheduledBy}
                      error={validation.errors.scheduledBy}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <BaseSelect
                      name="bdeStatus"
                      label={CommonLabel.Status}
                      placeholder={SelectPlaceHolder(CommonLabel.Status)}
                      options={BDEStatus}
                      value={validation.values.bdeStatus}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.bdeStatus}
                      error={validation.errors.bdeStatus}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-2">
                    <BaseSelect
                      name="round"
                      label={BdeLabel.Round}
                      placeholder={SelectPlaceHolder(BdeLabel.Round)}
                      options={BDERound}
                      value={validation.values.round}
                      handleChange={(field, value) => {
                        validation.setFieldValue(field, value);
                      }}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.round}
                      error={validation.errors.round}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-2">
                    <BaseInput
                      name="remark"
                      label={BdeLabel.Remark}
                      placeholder={InputPlaceHolder(BdeLabel.Remark)}
                      type="textarea"
                      value={validation.values.remark || ""}
                      onChange={validation.handleChange}
                      handleBlur={validation.handleBlur}
                      touched={validation.touched.remark}
                      error={validation.errors.remark}
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="hstack gap-2 justify-content-end">
                    <BaseButton type="submit" color="primary" loader={btnLoader}>
                      {bdeId === undefined
                        ? CommonLabel.Submit
                        : CommonLabel.Update}
                    </BaseButton>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Form>
      </Container>
    </div>
  );
};

export default BdeAddEdit;
